export const CAMPAIGN_STATUS = [
  { label: 'Gửi ngay', value: 'sent' },
  { label: 'Kế hoạch', value: 'scheduled' },
  { label: 'Đã hủy', value: 'cancelled' },
]

export const CAMPAIGN_TYPE = [
  { label: 'Thông báo + liên kết', value: 'notification_link' },
  { label: 'Thông báo + điểm thưởng', value: 'notification_reward' },
]

export const getCampaignStatus = (status: string) => {
  switch (status) {
    case 'sent':
      return [{ type: 'success', label: 'Gửi ngay' }]
    case 'scheduled':
      return [{ type: 'warn', label: 'Kế hoạch' }]
    case 'cancelled':
      return [{ type: 'danger', label: 'Đã hủy' }]
    default:
      return [{ type: 'info', label: status }]
  }
}

export const getCampaignType = (type: string) => {
  switch (type) {
    case 'notification_link':
      return [{ type: 'info', label: 'Thông báo + liên kết' }]
    case 'notification_reward':
      return [{ type: 'warn', label: 'Thông báo + điểm thưởng' }]
    default:
      return [{ type: 'info', label: type }]
  }
}

export const formatTableDataPushCampaign = (data: any) => {
  return data.map((item: any) => ({
    ...item,
    id: item.id,
    campaign_type: getCampaignType(item.type),
    status_text: getCampaignStatus(item.status),
    name: item.name,
    started_at: item.started_at,
    ended_at: item.ended_at,
    created_at: item.created_at,
    created_by: item?.created_by?.full_name || '-',
    sent_count: item.sent_count ? `${item.sent_count}/${item.total_count}` : '-',
    actions: { id: item.id, status: item.status },
  }))
}
